document.addEventListener('DOMContentLoaded', () => {

    const elements = document.querySelectorAll('.js-animation-wrapper')
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;

        return (
            rect.bottom >= -(200) &&
            rect.top <= (window.innerHeight || html.clientHeight) + 200 &&
            rect.left >= 0 &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }
    window.addEventListener("scroll", function(){
        elements.forEach(function(element) {
            if (isInViewport(element)) {
                const svg = element.getElementsByTagName('svg')[0]
                svg.className.baseVal = 'active'

            }
        })
    })

    elements.forEach(function(element) {
        if (isInViewport(element)) {
            const svg = element.getElementsByTagName('svg')[0]
            svg.className.baseVal = 'active'
        }
    })

})
